var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import * as types from './types';

export var initialState = {
  isConnected: true
};

export default function connection() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var payload = _ref.payload,
      type = _ref.type;

  switch (type) {
    case types.ON_CONNECTION_STATE_CHANGED:
      return _extends({}, state, payload);

    default:
      return state;
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/firekit/es/store/connection/reducer.js
// module id = 298
// module chunks = 49